import React from "react";

/**
 * PositionsTable — paper-trader /api/strategy/{id}/positions 응답 표시.
 *
 * paper-trader 가 mark price 기준으로 미실현 PnL 을 이미 계산해서 보내므로
 * 프론트는 단순 렌더링만 한다 (Position + MarkPrice + UnrealizedKRW + UnrealizedPct).
 */
export default function PositionsTable({ positions }) {
    if (!positions || positions.length === 0) {
        return (
            <div className="text-sm text-content-secondary py-4 text-center">
                활성 포지션 없음
            </div>
        );
    }
    return (
        <div className="overflow-x-auto">
            <table className="w-full text-xs">
                <thead>
                    <tr className="text-content-muted border-b border-surface-border">
                        <th className="text-left py-2 px-2 font-medium">심볼</th>
                        <th className="text-left py-2 px-2 font-medium">방향</th>
                        <th className="text-right py-2 px-2 font-medium">진입가</th>
                        <th className="text-right py-2 px-2 font-medium">현재가</th>
                        <th className="text-right py-2 px-2 font-medium">평가손익</th>
                        <th className="text-right py-2 px-2 font-medium">수익률</th>
                        <th className="hidden sm:table-cell text-right py-2 px-2 font-medium">TP / SL</th>
                    </tr>
                </thead>
                <tbody>
                    {positions.map((p, i) => {
                        const side = (p.Side || p.side || "").toLowerCase();
                        const sideClass =
                            side === "long" ? "text-gain" : side === "short" ? "text-loss" : "";
                        const upct = p.UnrealizedPct ?? p.unrealized_pct ?? 0;
                        const ukrw = p.UnrealizedKRW ?? p.unrealized_krw ?? 0;
                        const valueClass =
                            ukrw > 0 ? "text-gain" : ukrw < 0 ? "text-loss" : "text-content";
                        // 같은 심볼/방향으로 새 포지션이 열려도 EntryTs 가
                        // 다르므로 안정 키. index 폴백은 EntryTs 가 없는 응답 보호.
                        const k = `${p.Symbol || p.symbol}-${p.Side || p.side || ""}-${p.EntryTs || p.entry_ts || i}`;
                        return (
                            <tr
                                key={k}
                                className="border-b border-surface-border-light"
                            >
                                <td className="py-2 px-2 text-content">
                                    {p.Symbol || p.symbol}
                                </td>
                                <td className={`py-2 px-2 font-semibold ${sideClass}`}>
                                    {(p.Side || p.side || "").toUpperCase()}
                                </td>
                                <td className="py-2 px-2 text-right text-content">
                                    {fmt(p.EntryPrice ?? p.entry_price)}
                                </td>
                                <td className="py-2 px-2 text-right text-content">
                                    {fmt(p.MarkPrice ?? p.mark_price)}
                                </td>
                                <td className={`py-2 px-2 text-right font-semibold ${valueClass}`}>
                                    {Math.round(ukrw).toLocaleString()}
                                </td>
                                <td className={`py-2 px-2 text-right ${valueClass}`}>
                                    {upct.toFixed(2)}%
                                </td>
                                <td className="hidden sm:table-cell py-2 px-2 text-right text-content-secondary">
                                    {fmt(p.TPPrice ?? p.tp_price)} /{" "}
                                    {fmt(p.SLPrice ?? p.sl_price)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

function fmt(v) {
    if (v == null || isNaN(v)) return "—";
    const abs = Math.abs(v);
    if (abs >= 1000) return v.toLocaleString(undefined, { maximumFractionDigits: 1 });
    return v.toFixed(abs >= 1 ? 3 : 5);
}
